import ChangyanQrcodeImage from '../../../../assets/images/cy/cy-wx-qrcode.png'
import ChangyansunQrcodeImage from '../../../../assets/images/cy/cy-sun-qrcode.png'
import SuyuchunQrcodeImage from '../../../../assets/images/cy/cy-xiaoya-qrcode.png'

import {CY_MORE_SERVICE_LINKS} from "../../../../constants/CyHomepage";
import React from "react";
import {AdvancedLink} from "../../../../components";

const clsPrefix = 'c-our-infomation'


const CALLINGCARDSCONTENT = [
    {
        title:  '更多服务',
        children: (<div className={`${clsPrefix}__col`}>
                        {
                            CY_MORE_SERVICE_LINKS.map((item) => (
                                <AdvancedLink {...item} className='info-item' isOpenNewWindow />
                            ))
                        }
                    </div>)
    },
    {
        title: '在线咨询',
        children: (<div className={`${clsPrefix}__col`}>
            <div className='info-item'>免费客服热线</div>
            <a href='tel:400-106-0025' className='info-item'>400-106-0025</a>
            <div className='info-item'>周一至周五 9:30-18:30</div>
            <div className='info-item'>地址：北京市海淀区世纪科贸大厦B座</div>
        </div>)
    },
    {
        title: '问题反馈',
        children: (<div className={`${clsPrefix}__col`}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: '20px' }}>
                                <div style={{ marginBottom: '9px' }}>客服人员</div>
                                <div className='qrcode-container'>
                                    <img src={ChangyansunQrcodeImage} />
                                </div>
                            </div>
                            <div>
                                <div style={{ marginBottom: '9px' }}>畅言官方公众号</div>
                                <div className='qrcode-container'>
                                    <img src={ChangyanQrcodeImage} />
                                </div>
                            </div>
                        </div>
                    </div>)
    },
    {
        title: '商务合作',
        children: (<div className={`${clsPrefix}__col`}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: '20px' }}>
                                <div style={{ marginBottom: '9px' }}>商务总监</div>
                                <div className='qrcode-container'>
                                    <img src={`${SuyuchunQrcodeImage}`} />
                                </div>
                            </div>
                        </div>
                        <div className='info-item' style={{ marginTop: '12px' }}>商务合作：<a className='info-item' href='malito:suyuchun@icloudfuture.com'>suyuchun@icloudfuture.com</a></div>
                    </div>)
    }
]


export const INFOMATIONCONTENT = {
    CALLINGCARDSCONTENT,
    children: ''
}
